import React from "react";
import { Row, Col } from 'antd';
import Link from "antd/lib/typography/Link";
import { ITransferenceLinkProps } from './TransferenceLinkComponent.types';
import './TransferenceLinkComponent.scss';

const TransferenceLinkComponent = ({ transferenceHref, title, }: ITransferenceLinkProps) => {

  return (
    <>
      <Link href={transferenceHref} target={'_blank'} title={title}>
        <Row className="TransferenceLink">
          <Col>
            <div className={''}>Transferir ahora</div>
          </Col>
          <Col style={{ display: 'flex' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M6.33331 0.333313H2.99998C1.52731 0.333313 0.333313 1.52731 0.333313 2.99998V11C0.333313 12.4726 1.52731 13.6666 2.99998 13.6666H11C12.4726 13.6666 13.6666 12.4726 13.6666 11C13.6666 9.48598 13.6666 7.66665 13.6666 7.66665C13.6666 7.29865 13.368 6.99998 13 6.99998C12.632 6.99998 12.3333 7.29865 12.3333 7.66665V11C12.3333 11.736 11.736 12.3333 11 12.3333C8.77998 12.3333 5.21931 12.3333 2.99998 12.3333C2.26331 12.3333 1.66665 11.736 1.66665 11C1.66665 8.77998 1.66665 5.21931 1.66665 2.99998C1.66665 2.26331 2.26331 1.66665 2.99998 1.66665H6.33331C6.70131 1.66665 6.99998 1.36798 6.99998 0.99998C6.99998 0.63198 6.70131 0.333313 6.33331 0.333313ZM11.3906 1.66665H8.99998C8.63198 1.66665 8.33331 1.36798 8.33331 0.99998C8.33331 0.63198 8.63198 0.333313 8.99998 0.333313H13C13.368 0.333313 13.6666 0.63198 13.6666 0.99998V4.99998C13.6666 5.36798 13.368 5.66665 13 5.66665C12.632 5.66665 12.3333 5.36798 12.3333 4.99998V2.60931L7.47131 7.47131C7.21131 7.73131 6.78865 7.73131 6.52865 7.47131C6.26798 7.21131 6.26798 6.78865 6.52865 6.52865L11.3906 1.66665Z" fill="#004CC6" />
            </svg>
          </Col>
        </Row>
      </Link>
    </>
  )
}

export default TransferenceLinkComponent;
